import { createFileRoute, Outlet } from '@tanstack/react-router';
import AppLayout from '../components/AppLayout';
import { KeyboardShortcutsProvider } from '../components/KeyboardShortcutsModal/KeyboardShortcutsContext';
import { useCurrentUser } from '../services/userHooks';
import { useAuthRedirect } from '../hooks/useAuthRedirect';
import usePrefetchHomeBookmarks from '../hooks/usePrefetchHomeBookmarks';

export const Route = createFileRoute('/_app')({
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { currentUser, isLoading, isError } = useCurrentUser();
  usePrefetchHomeBookmarks();
  useAuthRedirect(isLoading, isError, currentUser);

  return (
    <KeyboardShortcutsProvider>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </KeyboardShortcutsProvider>
  );
}
